export const payments = {
    state: {
        paymentMethods: []
    },
    mutations: {
        SET_PAYMENTMETHODS(state, paymentMethods) {
            state.paymentMethods = paymentMethods
        }
    },
    actions: {
        fetchPaymentMethods({ commit, getters }) {
            return new Promise((resolve, reject) => {
                this.$api.get('b2b/v2/payments/methods').then(response => {
                    commit('SET_PAYMENTMETHODS', response.data.data)
                    resolve()
                })
            })
        }
    },
    getters: {
        paymentMethods: (state) => {
            return state.paymentMethods
        }
    }
}
